import { docValidations } from "./docValidation";

const global = {
  complete: `Completar`,
  address: `Dirección`,
  email: `Correo electrónico`,
  accepted: `Aceptado`,
  not_accepted: `No aceptado`,
  individual_information: `Información individual`,
  full_name: `Nombre completo`,
  nationality: `Nacionalidad`,
  document: `Documento`,
  terms_and_conditions: `Términos y condiciones`,
  updated_by: `Actualizado por`,
  updated_on: `Actualizado el`,
  last_created_by: `Creado por {{createdBy}} el {{createdOn}}`,
  last_updated_by: `Última actualización realizada por {{updatedBy}} el {{lastUpdated}}`,
  last_updated_on: `Última actualización: {{lastUpdated}}`,
  last_deleted_by: `Última eliminación realizada por {{deletedBy}} el {{deletedOn}}`,
  connecting: `Conectando`,
  today: `Hoy`,
  load_more: "Cargar más",
  download_csv: "Descargar CSV",
  end_of_result: `Fin del resultado`,
  recipient: `Beneficiario`,
  note: `Nota`,
  total_balance: "Saldo total",
  file_name: `Nombre del archivo`,
  account: `Cuenta`,
  company_id: `ID de la empresa`,
  view_history: `Ver historial`,
  view_change_logs: `Ver registros de cambios`,
  include_onboarded_users: `Incluir usuarios incorporados`,
  show_onboarded_customers: `Mostrar clientes incorporados`,
  show_onboarded_suppliers: `Mostrar proveedores incorporados`,
  disconnect: `Desconectar`,
  configure: "Configurar",
  documents: `Documentos`,
  in_process: `En proceso`,
  connect: `Conectar`,
  continue: `Continuar`,
  compliance: `Cumplimiento`,
  PartialPaid: `Pago a cuenta`,
  create: `Crear`,
  "Preview only – not compliant for official use.": `Solo vista previa – no apto para uso oficial.`,
  bic: `Código Swift / Código de información bancaria`,
  debitorAccountHolderName: `Nombre del titular de la cuenta del deudor`,
  debitorIBAN: `IBAN del deudor`,
  exportedBy: `Exportado por`,
  characters: `Caracteres`,
  "Export Payment Template": `Exportar plantilla de pago`,
  transactionId: `ID de transacción`,
  transactionStatus: `Estado de la transacción`,
  createdBy: `Creado por`,
  templateId: `ID de plantilla`,
  destination: `Destino`,
  supported_documents: `Documentos de apoyo`,
  no_supported_documents_found: `No se encontraron documentos de apoyo`,
  expiry_date: `Fecha de caducidad`,
  document_name_is_required: `El nombre del documento es obligatorio`,
  documents_uploaded_successfully: `{{count}} documentos se cargaron correctamente`,
  documents_upload_failed: `{{count}} documentos no se pudieron cargar`,
  delete_document: `Eliminar documento`,
  this_action_cannot_be_undone: `Esta acción no se puede deshacer`,
  unsaved_changes: `Cambios no guardados`,
  unsaved_changes_warning: `Tienes cambios no guardados. ¿Estás seguro de que deseas continuar?`,
  discard_and_continue: `Descartar y continuar`,
  document_upload_failed: `La carga del documento falló`,
  upload_support_document: `Subir documento de soporte`,
  upload_supplier_support_document: `Subir documento de soporte del proveedor`,
  add_expiry_date: `Añadir fecha de caducidad`,
  document_expires_on: `Caduca el {{expiryDate}}`,
  document_expired_on: `Caducó el {{expiryDate}}`,

  expiry_date_cannot_be_in_the_past: `La fecha de caducidad no puede ser anterior a la fecha de vencimiento.`,
  document_updated_successfully: `Documento cargado correctamente`,
  upload_your_document: `Sube tu documento`,
  drag_and_drop_your_files_here: `Arrastra y suelta tus archivos aquí`,
  browse_files: `Explorar archivos`,
  files_accepted_only: `Solo se aceptan archivos {{acceptedFiles}}`,
  upload_and_manage_support_documents: `Subir y gestionar documentos de soporte`,
  save_document: `Guardar documento`,
  set_document_expiry: `Establecer fecha de caducidad del documento`,
  upload_new: `Subir nuevo`,
  update_document: `Actualizar documento`,
  expiry_date_is_required: `Se requiere fecha de caducidad`,
  expiry_date_cannot_be_less_than_current_date: `La fecha de vencimiento no puede ser anterior a la fecha actual`,
  bank_accounts: `Cuentas Bancarias`,
  yesterday: "Ayer",
  this_week: "Esta semana",
  last_week: "La semana pasada",
  this_month: "Este mes",
  last_month: "El mes pasado",
  this_quarter: "Este trimestre",
  last_quarter: "El trimestre pasado",
  this_year: "Este año",
  last_year: "El año pasado",
  custom: "Personalizado",
  receivables: `Cuentas por cobrar`,
  sales_invoices: `Facturas De Venta`,
  sales_orders: `Pedidos de venta`,
  sales_delivery_note: `Albaranes De Venta`,
  "sales-invoices": `Facturas de venta`,
  "sale-invoice": `Facturas De Venta`,
  email_documents_to_dost_portal: `Enviar documentos por correo electrónico al portal Dost`,
  scan_with_Dost_Upload_App: `Escanear con la aplicación Dost Upload`,
  upload_via_qr_code: `Subir mediante código QR`,
  png_pdf_jpeg: `PNG, PDF, JPEG`,
  receive_via_customer_portal: `Recibir a través del portal del cliente`,
  customer_uploads_directly_in_customer_portal: `El cliente carga los documentos directamente en el portal del cliente`,
  receive_via_supplier_portal: `Recibir a través del Portal de Proveedores`,
  supplier_uploads_directly_in_supplier_portal: `El proveedor carga los documentos directamente en el Portal de Proveedores`,
  view_received_emails: `Ver correos electrónicos recibidos`,
  Receive: `Recibir`,
  Create: `Crear`,
  "Verifactu - Regular Invoice": `Verifactu - Factura ordinaria`,
  "Verifactu - Simplified Invoice": `Verifactu - Factura simplificada`,
  "SDI - Regular Invoice": `SDI - Factura ordinaria`,
  "SII - Regular Invoice": `SII - Factura ordinaria`,
  "SII - Simplified Invoice": `SII - Factura simplificada`,
  "Sale Delivery Note": `Albarán de venta`,
  "Purchase Order": `Orden de compra`,
  "PA(France) - Regular Invoice": `PA(Francia) - Factura ordinaria`,
  sync_documents_from_email_and_other_connected_datasources: `Sincronizar documentos desde el correo electrónico y otras fuentes de datos conectadas`,
  view_existing_drafts: `Ver borradores existentes`,
  "sale-order": `Pedidos De Venta`,
  "sale-delivery-note": `Albaranes De Venta`,
  payables: `Cuentas por pagar`,
  dimensions: `Dimensiones`,
  purchase_invoices: `Facturas De Compra`,
  purchase_orders: `Órdenes De Compra`,
  purchase_delivery_note: `Albaranes de compra`,
  "purchase-invoice": `Facturas De Compra`,
  "purchase-order": `Órdenes De Compra`,
  "purchase-deliverynote": `Albarán De Compra`,
  RegularInvoice: `Factura Regular`,
  SimplifiedInvoice: `Factura Simplificada`,
  CreditNote: `Nota de Crédito`,
  DebitNote: `Nota de Débito`,
  CorrectiveInvoice: `Factura Correctiva`,
  CancelInvoice: `Factura de Cancelación`,
  ReplacementInvoice: `Factura de Reemplazo`,
  delivery_note_number: `N.º de albarán`,
  purchase_order_number: `N.º de orden de compra`,
  sale_order_number: `N.º de orden de venta`,
  not_found: `No encontrado`,
  vendor: `Proveedor`,
  integrated: `Integrado`,
  not_integrated: `No integrado`,
  drafts: `Borradores`,
  actions: `Acciones`,
  documentClass_drafts: `Borradores de {{documentClass}}`,
  no_compliance_standard_found: `No se encontró ningún estándar de cumplimiento`,
  save_as_draft: `Guardar como borrador`,
  draft_delete_title: `¿Está seguro de que desea eliminar este borrador?`,
  draft_delete_warning: `Esta acción no se puede deshacer. El borrador se eliminará permanentemente.`,
  document_draft_saved_successfully: `Borrador del documento guardado correctamente`,

  draft_deleted_successfully: `El borrador se eliminó correctamente`,
  failed_to_delete_draft: `Error al eliminar el borrador`,
  ...docValidations,
  FrancePA: `PA(Francia)`,
  france_regular_invoice: `PA(Francia) Factura regular`,
  FrancePA_document: `Documento PA(Francia)`,
  companies: `Empresas`,
  selftrainginProject: `Proyecto de autoentrenamiento`,
  selftrainginMatchingTag: `Etiqueta de coincidencia de autoentrenamiento`,
  doc_date: `Fecha del documento`,
  invoice_no: `Número de factura`,
  doc_status: `Estado del documento`,
  erp_status: `Estado del ERP`,
  customer: `Cliente`,
  protocol: `Protocolo`,
  unclassified_documents: `Documentos `,
  unclassified: `Sin Clasificar`,
  discard: `Descartar`,
  confirm_mapping_upload_text: `¿Está seguro de que desea eliminar la asignación anterior?`,
  confirm_mapping_upload_subtitle: `Todas sus asignaciones existentes se eliminarán y no se utilizarán para asignar valores a los campos conectados en el futuro`,
  send_pa_status: `Enviar estado de PA`,
  send_pa_status_subtitle: `Gestionar el estado de su factura de Francia (PA)`,
  rejection_reason: `Motivo del rechazo`,
  pa_status_sent_successfully: `El estado de PA se envió correctamente.`,
  status_is_required: `El estado es obligatorio`,
  total_enabled: `{{selected}} de {{total}} habilitados`,
  chart: `Gráfico`,
  delete_chart: `Eliminar gráfico`,
  category: `Categoría`,
  delete_visualization: "Eliminar visualización",
  delete_visualization_confirmation:
    "¿Está seguro de que desea eliminar esta visualización?",
  delete_role: "Eliminar rol",
  delete_this_field: "Eliminar este campo",
  create_role: "Crear rol",
  edit_role: "Editar rol",
  role_name: "Nombre del rol",
  enter_role_name: "Introduzca el nombre del rol",
  create_new_role_and_assign_it_module_wise_permissions:
    "Cree un nuevo rol y asígnele permisos por módulo",
  all_modules: "Todos los módulos",
  filter_roles_by_name: "Filtrar roles por nombre",
  out_permissions_enabled: "{{selected}} de {{total}} permisos habilitados",
  search_modules: "Buscar",
  get_input_mappings: `Obtener asignaciones de entrada`,
  get_workflows: `Obtener flujos de trabajo`,
  show_more: `Mostrar más`,
  show_less: `Mostrar menos`,
  accept: `Aceptar`,
  SystemAdmin_role_cannot_be_combined_with_other_roles: `El rol de SystemAdmin no se puede combinar con otros roles`,
  is_signed: `Está firmado`,
  OrganizationName_allowed_letters_numbers_and_spaces: `El nombre de la organización solo puede contener letras, números y espacios`,
  OrganizationSector_allowed_letters_numbers_and_spaces: `El sector de la organización solo puede contener letras, números y espacios`,
  webhook_configuration: `Configuración del webhook`,
  webhook_events: `Eventos de webhook`,
  acknowledge_invoice: `Reconocer factura`,
  acknowledge: `Reconocer`,
  isAgreed: `¿Está de acuerdo?`,
  acknowledgedBy: `Reconocido por`,
  Note: `Nota`,
  ack_ap_invoice_report: `Reconocer informe de factura de proveedores`,
  acknowledged: `Admitido - {{status}}`,
  // Procurement
  purchase_requisitions: `Requisiciónes de compra`,
  "purchase-requisition":`Requisiciónes de compra`,
  create_purchase_requisition: `Crear requisición de compra`,
  procurement: `Adquisiciones`,
  grn: `Albarán de recepción`,
  grn_number: `Número de GRN`,
  grn_delivery_reference: `Referencia de entrega de GRN`,
  requester: `Solicitante`,
  department: `Departamento`,
  updated_date: `Fecha de actualización`,
  purchase_requisition_drafts: `Purchase requisition drafts`,
  purchase_requisition_deleted_successfully: `Solicitud eliminada correctamente`,
  cannot_delete_posted_requisition: `No se puede eliminar la solicitud publicada`,
  delete_purchase_requisition_confirmation: `¿Está seguro de que desea eliminar esta requisición de compra?`,
  vendor_information_is_required: `La información del proveedor es obligatoria`,
  purchase_requisition_is_being_processing: `La solicitud de compra está siendo procesada`,
  copy_email: `Copiar correo electrónico`,
  filter_by_property: `Filtrar por propiedad`,
  filter_by_value: `Filtrar por valor`,
  filter_by_description_or_value: `Filtrar por descripción o valor`,
  save_as_default: `Guardar como predeterminado`,
  select_a_property: `Seleccione una propiedad`,
  type_to_search_value: `Escriba para buscar un valor..`,
  add_filter: `Agregar filtro`,
  finalize: `Finalizar`,
  finalized: `Finalizada`,
  finalized_successfully: `Finalizado con éxito`,
  finalize_purchase_requisition_confirmation: `¿Está seguro de que desea finalizar esta requisición de compra? Una vez finalizada, no se podrá editar ni eliminar.`,
  purchase_requisition_already_finalized:
    "La requisición de compra ya está finalizada.",
  configuration_already_set: "La configuración ya está establecida.",
  docconfig_not_save: `Configuración del documento no guardada`,
  finalize_purchase_order_confirmation: `¿Está seguro de que desea finalizar esta orden de compra? Una vez finalizada, no se podrá editar ni eliminar.`,
  post: `Contabilizar`,
  posted: `Contabilizada`,
  draft: `Borrador`,
  submitted: `Enviada`,
  discarded: `Descartada`,
  posted_successfully: `Contabilizado con éxito`,
  post_purchase_requisition_confirmation: `¿Está seguro de que desea contabilizar esta requisición de compra? Una vez contabilizada, no se podrá editar ni eliminar.`,
  post_purchase_order_confirmation: `¿Está seguro de que desea contabilizar esta orden de compra? Una vez contabilizada, no se podrá editar ni eliminar.`,
  create_po_from_pr: `Crear PO a partir de PR`,
  additional_field_is_required: `El campo adicional {{field}} es obligatorio`,
  purchase_order_drafts: `Borradores de órdenes de compra`,
  purchase_order_id: `ID de orden de compra`,
  vendor_company_name: `Nombre de la empresa proveedora`,
  created_date: `Fecha de creación`,
  permission_denied: `Permiso denegado`,
  "Purchase Order is already finalized.":
    "La orden de compra ya está finalizada.",
  logo_url_invalid:
    "La URL del logotipo debe ser de un tipo de imagen válido (jpg, jpeg, png, gif).",
  document_number_required: "El número de documento es obligatorio.",
  document_date_invalid:
    "La fecha del documento debe ser una fecha válida y no puede ser la fecha mínima predeterminada.",
  customer_company_name_required:
    "El nombre de la empresa del cliente es obligatorio.",
  customer_company_id_required:
    "El ID de la empresa del cliente es obligatorio.",
  customer_email_required: "El correo electrónico del cliente es obligatorio.",
  vendor_company_name_required:
    "El nombre de la empresa del proveedor es obligatorio.",
  vendor_email_required: "El correo electrónico del proveedor es obligatorio.",
  vendor_company_id_required:
    "El ID de la empresa del proveedor es obligatorio.",
  vendor_customer_company_id_same:
    "El 'ID de la empresa del proveedor' y el 'ID de la empresa del cliente' no pueden ser iguales.",
  vendor_customer_email_same:
    "El 'correo electrónico del proveedor' y el 'correo electrónico del cliente' no pueden ser iguales.",
  vendor_customer_company_name_same:
    "El 'nombre de la empresa del proveedor' y el 'nombre de la empresa del cliente' no pueden ser iguales.",
  vendor_customer_company_address_same:
    "La 'dirección de la empresa del proveedor' y la 'dirección de la empresa del cliente' no pueden ser iguales.",
  currency_required: "La moneda es obligatoria.",
  total_without_tax_invalid: "El total sin impuestos debe ser mayor que 0.",
  items_required: "Se requiere al menos 1 artículo.",
  vat_tax_conflict:
    "La información del IVA debe proporcionarse en la tabla de impuestos o en los artículos, pero no en ambos.",
  tax_type_required:
    "El tipo de impuesto es obligatorio en la tabla de impuestos.",
  discount_conflict:
    "La información del descuento debe proporcionarse en el campo 'Descuento total' o en los artículos, pero no en ambos.",
  uploaded_document_invalid_type: "Solo se permiten archivos PDF o de imagen.",
  item_reference_code_required:
    "El código de referencia del artículo es obligatorio.",
  item_description_required: "La descripción del artículo es obligatoria.",
  item_quantity_invalid:
    "La cantidad del artículo (con código de referencia y descripción) debe ser mayor que 0.",
  item_unit_price_invalid:
    "El precio unitario del artículo (con código de referencia y descripción) debe ser mayor que 0.",
  item_tax_type_invalid:
    "El tipo de impuesto del artículo (con código de referencia y descripción) no puede ser 'WHT' o 'IRPF'. Debe definirse en la tabla de impuestos.",
  purchase_requisition_number: `Número de solicitud de compra`,
  edit_document: `Editar documento`,
  created_in_dost: `Creado en Dost`,
  // role & sub user deletion blocked by workflow usage (needs review)
  role_has_pending_workflow_tasks: `El rol no se puede eliminar porque tiene tareas de flujo de trabajo pendientes`,
  role_used_in_active_workflow_templates: `El rol no se puede eliminar porque se utiliza en plantillas de flujo de trabajo activas`,
  user_has_pending_workflow_tasks: `El usuario no se puede eliminar porque tiene tareas de flujo de trabajo pendientes`,
  user_used_in_active_workflow_templates: `El usuario no se puede eliminar porque está asignado en plantillas de flujo de trabajo activas`,
  document_pendingtask:`La tarea del documento está pendiente.`,

};
export default global;
